var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Styles from "./BouncingBalls.module.css";
const BouncingBalls = (_a) => {
    var { className = "", color = "#0d6efd", width = "0.8em", height = "0.8em", duration = "0.4s", style } = _a, others = __rest(_a, ["className", "color", "width", "height", "duration", "style"]);
    return (React.createElement("div", Object.assign({}, others, { style: Object.assign(Object.assign({}, style), { ["--width"]: width, ["--height"]: height, ["--color"]: color, ["--duration"]: duration }), className: `${Styles["balls"]} ${className}` }),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)));
};
export default BouncingBalls;
//# sourceMappingURL=index.js.map